/** Generated by scripts/lesson_plans/export_feed_from_lessons.py — do not edit by hand. */

const EXAMPLES = {
  "celtic-ireland-regions-celtic-ireland-01-overview-kp-1": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-01-overview-kp-2": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-01-overview-kp-3": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-01-overview-sec-1-overview": {
    "kind": "none",
    "illustrationPlan": "Overview — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-01-overview-sec-2-trad-versus-celtic-labels-that-help-and-mislead": {
    "kind": "none",
    "illustrationPlan": "\"Trad\" versus \"Celtic\": labels that help and mislead",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-01-overview-sec-3-the-gaeltacht-and-the-oral-tradition": {
    "kind": "none",
    "illustrationPlan": "The Gaeltacht and the oral tradition — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-01-overview-sec-4-the-session-seisiún": {
    "kind": "none",
    "illustrationPlan": "The session (*seisiún*) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-01-overview-sec-5-tune-types-a-field-guide-with-memorable-details": {
    "kind": "none",
    "illustrationPlan": "Tune types: a field guide with memorable details",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-01-overview-sec-6-song-a-parallel-river-preview": {
    "kind": "none",
    "illustrationPlan": "Song: a parallel river (preview) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-01-overview-sec-7-social-settings-where-music-happens": {
    "kind": "none",
    "illustrationPlan": "Social settings: where music happens — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-01-overview-sec-8-institutions-that-shape-the-tradition": {
    "kind": "none",
    "illustrationPlan": "Institutions that shape the tradition — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-01-overview-sec-9-regional-map-five-accents-to-know": {
    "kind": "none",
    "illustrationPlan": "Regional map: five accents to know — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-01-overview-sec-10-ancient-roots-a-preview-of-lesson-6": {
    "kind": "none",
    "illustrationPlan": "Ancient roots — a preview of Lesson 6 — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-01-overview-sec-11-unesco-uilleann-piping-2017": {
    "kind": "none",
    "illustrationPlan": "UNESCO: uilleann piping, 2017 — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-01-overview-sec-12-fusion-and-the-wider-world-briefly": {
    "kind": "none",
    "illustrationPlan": "Fusion and the wider world (briefly) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-01-overview-sec-13-how-this-unit-is-organised": {
    "kind": "none",
    "illustrationPlan": "How this unit is organised — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-01-overview-sec-14-starting-points-for-learners": {
    "kind": "none",
    "illustrationPlan": "Starting points for learners — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-01-overview-sec-15-reading-and-listening-list-orientation": {
    "kind": "none",
    "illustrationPlan": "Reading and listening list (orientation)",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-kp-1": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-kp-2": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-kp-3": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-1-overview": {
    "kind": "none",
    "illustrationPlan": "Overview — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-2-session-roles-overlap": {
    "kind": "none",
    "illustrationPlan": "Session roles overlap — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-3-irish-fiddle": {
    "kind": "none",
    "illustrationPlan": "Irish fiddle — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-4-technique-posture-and-ornament": {
    "kind": "none",
    "illustrationPlan": "Technique, posture, and ornament — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-5-session-and-band-role": {
    "kind": "none",
    "illustrationPlan": "Session and band role — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-6-regional-schools-donegal-sligo-and-clare": {
    "kind": "none",
    "illustrationPlan": "Regional schools: Donegal, Sligo, and Clare",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-7-famous-players-and-memorable-details": {
    "kind": "none",
    "illustrationPlan": "Famous players and memorable details — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-9-historical-notes": {
    "kind": "none",
    "illustrationPlan": "Historical notes — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-10-irish-flute": {
    "kind": "none",
    "illustrationPlan": "Irish flute — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-11-technique-and-cultural-context": {
    "kind": "none",
    "illustrationPlan": "Technique and cultural context — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-12-session-and-band-role": {
    "kind": "none",
    "illustrationPlan": "Session and band role — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-13-famous-players": {
    "kind": "none",
    "illustrationPlan": "Famous players — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-14-simple-system-versus-boehm-why-it-matters": {
    "kind": "none",
    "illustrationPlan": "Simple-system versus Boehm: why it matters",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-18-technique-and-cultural-context": {
    "kind": "none",
    "illustrationPlan": "Technique and cultural context — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-20-famous-players": {
    "kind": "none",
    "illustrationPlan": "Famous players — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-23-uilleann-pipes": {
    "kind": "none",
    "illustrationPlan": "Uilleann pipes — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-24-technique-bellows-bag-chanter-regulators": {
    "kind": "none",
    "illustrationPlan": "Technique: bellows, bag, chanter, regulators",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-26-famous-players": {
    "kind": "none",
    "illustrationPlan": "Famous players — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-28-historical-notes": {
    "kind": "none",
    "illustrationPlan": "Historical notes — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-29-celtic-harp-cláirseach": {
    "kind": "none",
    "illustrationPlan": "Celtic harp (cláirseach) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-30-technique-and-cultural-context": {
    "kind": "none",
    "illustrationPlan": "Technique and cultural context — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-32-famous-players-and-carolan": {
    "kind": "none",
    "illustrationPlan": "Famous players and Carolan — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-33-harp-in-session-versus-concert": {
    "kind": "none",
    "illustrationPlan": "Harp in session versus concert — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-36-how-these-five-voices-fit-together": {
    "kind": "none",
    "illustrationPlan": "How these five voices fit together — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-02-instruments-voices-i-sec-37-cross-instrument-comparison-table": {
    "kind": "none",
    "illustrationPlan": "Cross-instrument comparison table — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-kp-1": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-kp-2": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-kp-3": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-sec-1-overview": {
    "kind": "none",
    "illustrationPlan": "Overview — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-sec-2-session-roles-overlap": {
    "kind": "none",
    "illustrationPlan": "Session roles overlap — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-sec-3-bodhrán": {
    "kind": "none",
    "illustrationPlan": "Bodhrán — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-sec-4-technique-posture-and-ornament": {
    "kind": "none",
    "illustrationPlan": "Technique, posture, and ornament — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-sec-5-session-and-band-role": {
    "kind": "none",
    "illustrationPlan": "Session and band role — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-sec-16-technique-and-cultural-context": {
    "kind": "none",
    "illustrationPlan": "Technique and cultural context — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-sec-18-famous-players": {
    "kind": "none",
    "illustrationPlan": "Famous players — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-sec-24-famous-players": {
    "kind": "none",
    "illustrationPlan": "Famous players — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-sec-25-bouzouki-versus-guitar-in-the-same-session": {
    "kind": "none",
    "illustrationPlan": "Bouzouki versus guitar in the same session",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-sec-38-famous-players": {
    "kind": "none",
    "illustrationPlan": "Famous players — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-sec-43-session-and-band-role": {
    "kind": "none",
    "illustrationPlan": "Session and band role — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-sec-44-famous-players": {
    "kind": "none",
    "illustrationPlan": "Famous players — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-sec-50-famous-players": {
    "kind": "none",
    "illustrationPlan": "Famous players — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-sec-59-planxty-and-the-modern-ensemble-template": {
    "kind": "none",
    "illustrationPlan": "Planxty and the modern ensemble template",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-sec-60-putting-the-ensemble-together": {
    "kind": "none",
    "illustrationPlan": "Putting the ensemble together — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-03-instruments-voices-ii-sec-61-session-etiquette-checklist": {
    "kind": "none",
    "illustrationPlan": "Session etiquette checklist — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-kp-1": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-kp-2": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-kp-3": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-1-overview": {
    "kind": "none",
    "illustrationPlan": "Overview — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-2-how-to-listen-metre-pulse-and-feel": {
    "kind": "none",
    "illustrationPlan": "How to listen: metre, pulse, and feel — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-3-reels": {
    "kind": "none",
    "illustrationPlan": "Reels — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-5-double-jigs-68": {
    "kind": "none",
    "illustrationPlan": "Double jigs (6/8) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-6-single-jigs": {
    "kind": "none",
    "illustrationPlan": "Single jigs — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-7-slip-jigs-98": {
    "kind": "none",
    "illustrationPlan": "Slip jigs (9/8) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-8-hornpipes": {
    "kind": "none",
    "illustrationPlan": "Hornpipes — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-9-polkas": {
    "kind": "none",
    "illustrationPlan": "Polkas — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-10-slides-128-tune-type": {
    "kind": "none",
    "illustrationPlan": "Slides (12/8 tune type) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-11-reading-the-session-from-foot-tap-to-tune-name": {
    "kind": "none",
    "illustrationPlan": "Reading the session: from foot-tap to tune name",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-12-mazurkas-and-continental-metres": {
    "kind": "none",
    "illustrationPlan": "Mazurkas and continental metres — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-13-highlands-strathspeys-and-scottish-overlap": {
    "kind": "none",
    "illustrationPlan": "Highlands, strathspeys, and Scottish overlap",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-20-instrument-specific-notes": {
    "kind": "none",
    "illustrationPlan": "Instrument-specific notes — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-22-regional-styles": {
    "kind": "none",
    "illustrationPlan": "Regional styles — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-24-repertoire-and-function": {
    "kind": "none",
    "illustrationPlan": "Repertoire and function — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-26-ballad-culture-narrative-emigration-and-politics": {
    "kind": "none",
    "illustrationPlan": "Ballad culture: narrative, emigration, and politics",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-27-the-ballad-boom-and-pub-stages": {
    "kind": "none",
    "illustrationPlan": "The ballad boom and pub stages — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-29-drinking-songs-laments-and-work-songs": {
    "kind": "none",
    "illustrationPlan": "Drinking songs, laments, and work songs — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-30-culture-of-lyrics-language-poetry-and-communal-singing": {
    "kind": "none",
    "illustrationPlan": "Culture of lyrics: language, poetry, and communal singing",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-31-liliting-portaireacht": {
    "kind": "none",
    "illustrationPlan": "Liliting (portaireacht) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-32-slow-airs": {
    "kind": "none",
    "illustrationPlan": "Slow airs — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-36-tune-naming": {
    "kind": "none",
    "illustrationPlan": "Tune naming — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-37-famous-tunes-and-songs-a-starter-map": {
    "kind": "none",
    "illustrationPlan": "Famous tunes and songs: a starter map — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-38-francis-oneill-and-the-printed-tradition": {
    "kind": "none",
    "illustrationPlan": "Francis O'Neill and the printed tradition",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-39-when-forms-collide-medleys-surprises-and-session-politics": {
    "kind": "none",
    "illustrationPlan": "When forms collide: medleys, surprises, and session politics",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-04-genres-forms-sec-40-style-checklist-for-learners": {
    "kind": "none",
    "illustrationPlan": "Style checklist for learners — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-kp-1": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-kp-2": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-kp-3": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-1-overview": {
    "kind": "none",
    "illustrationPlan": "Overview — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-2-travelling-dance-masters-17th18th-centuries": {
    "kind": "none",
    "illustrationPlan": "Travelling dance masters (17th–18th centuries)",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-3-what-masters-taught": {
    "kind": "none",
    "illustrationPlan": "What masters taught — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-4-from-kitchen-to-classroom": {
    "kind": "none",
    "illustrationPlan": "From kitchen to classroom — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-5-social-dance-three-broad-families": {
    "kind": "none",
    "illustrationPlan": "Social dance: three broad families — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-7-figures-and-repertoire": {
    "kind": "none",
    "illustrationPlan": "Figures and repertoire — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-8-céilí-bands": {
    "kind": "none",
    "illustrationPlan": "Céilí bands — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-9-learning-céilí-as-a-musician": {
    "kind": "none",
    "illustrationPlan": "Learning céilí as a musician — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-11-regional-sets": {
    "kind": "none",
    "illustrationPlan": "Regional sets — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-13-the-1980s90s-revival": {
    "kind": "none",
    "illustrationPlan": "The 1980s–90s revival — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-14-clare-sets-in-depth": {
    "kind": "none",
    "illustrationPlan": "Clare sets in depth — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-17-an-coimisiún-le-rincí-gaelacha": {
    "kind": "none",
    "illustrationPlan": "An Coimisiún le Rincí Gaelacha — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-18-feiseanna-culture": {
    "kind": "none",
    "illustrationPlan": "Feiseanna culture — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-19-soft-shoe-versus-hard-shoe-in-competition": {
    "kind": "none",
    "illustrationPlan": "Soft shoe versus hard shoe in competition",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-22-festival-dance-a-separate-competitive-tradition": {
    "kind": "none",
    "illustrationPlan": "Festival dance: a separate competitive tradition",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-26-improvisation-and-context": {
    "kind": "none",
    "illustrationPlan": "Improvisation and context — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-29-riverdance-19941995-onward": {
    "kind": "none",
    "illustrationPlan": "Riverdance (1994–1995 onward) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-32-what-changed-for-musicians": {
    "kind": "none",
    "illustrationPlan": "What changed for musicians — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-38-ballad-boom-and-dance-halls-1960s70s": {
    "kind": "none",
    "illustrationPlan": "Ballad boom and dance halls (1960s–70s) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-39-showbands-and-the-ballroom-economy": {
    "kind": "none",
    "illustrationPlan": "Showbands and the ballroom economy — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-40-comhaltas-branches-and-weekly-classes": {
    "kind": "none",
    "illustrationPlan": "Comhaltas branches and weekly classes — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-42-who-leads-whom": {
    "kind": "none",
    "illustrationPlan": "Who leads whom? — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-43-tempo-arguments": {
    "kind": "none",
    "illustrationPlan": "Tempo arguments — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-44-rhythm-table-for-musicians": {
    "kind": "none",
    "illustrationPlan": "Rhythm table for musicians — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-46-hiring-protocol-for-dance-gigs": {
    "kind": "none",
    "illustrationPlan": "Hiring protocol for dance gigs — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-48-dance-nationalism-and-identity": {
    "kind": "none",
    "illustrationPlan": "Dance, nationalism, and identity — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-50-looking-ahead-dance-in-the-fusion-lesson": {
    "kind": "none",
    "illustrationPlan": "Looking ahead: dance in the fusion lesson",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-51-step-vocabulary-for-musicians-glossary": {
    "kind": "none",
    "illustrationPlan": "Step vocabulary for musicians (glossary)",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-52-oireachtas-na-gaeilge-and-the-irish-language-pole": {
    "kind": "none",
    "illustrationPlan": "Oireachtas na Gaeilge and the Irish-language pole",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-05-dance-sec-53-house-parties-kitchens-and-the-informal-floor": {
    "kind": "none",
    "illustrationPlan": "House parties, kitchens, and the informal floor",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-kp-1": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-kp-2": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-kp-3": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-1-overview": {
    "kind": "none",
    "illustrationPlan": "Overview — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-2-the-annals-musicians-in-medieval-ireland": {
    "kind": "none",
    "illustrationPlan": "The annals: musicians in medieval Ireland",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-3-early-poetry-hymns-and-song-roots": {
    "kind": "none",
    "illustrationPlan": "Early poetry, hymns, and song roots — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-4-irish-musicians-abroad-early-medieval-to-early-modern": {
    "kind": "none",
    "illustrationPlan": "Irish musicians abroad — early medieval to early modern",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-5-harp-patronage-carolan-and-the-belfast-festival": {
    "kind": "none",
    "illustrationPlan": "Harp patronage, Carolan, and the Belfast festival",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-6-polkas-set-dancing-and-nineteenth-century-dance-imports": {
    "kind": "none",
    "illustrationPlan": "Polkas, set dancing, and nineteenth-century dance imports",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-7-collectors-and-print-freezing-and-saving": {
    "kind": "none",
    "illustrationPlan": "Collectors and print: freezing and saving",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-8-diaspora-and-the-78-rpm-loop": {
    "kind": "none",
    "illustrationPlan": "Diaspora and the 78 rpm loop — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-9-revival-ó-riada-ceoltóirí-chualann-and-the-chieftains": {
    "kind": "none",
    "illustrationPlan": "Revival: Ó Riada, Ceoltóirí Chualann, and the Chieftains",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-10-comhaltas-the-fleadh-and-the-competition-pyramid": {
    "kind": "none",
    "illustrationPlan": "Comhaltas, the Fleadh, and the competition pyramid",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-11-willie-clancy-summer-school-and-the-festival-ecosystem": {
    "kind": "none",
    "illustrationPlan": "Willie Clancy Summer School and the festival ecosystem",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-12-itma-na-píobairí-uilleann-and-unesco": {
    "kind": "none",
    "illustrationPlan": "ITMA, Na Píobairí Uilleann, and UNESCO — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-13-transmission-today-competition-session-and-the-internet": {
    "kind": "none",
    "illustrationPlan": "Transmission today: competition, session, and the internet",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-14-same-tune-many-versions-a-case-study-mindset": {
    "kind": "none",
    "illustrationPlan": "Same tune, many versions — a case study mindset",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-15-penal-laws-language-shift-and-what-survived": {
    "kind": "none",
    "illustrationPlan": "Penal laws, language shift, and what survived",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-16-arthur-oneill-patrick-byrne-and-the-nineteenth-century-stage": {
    "kind": "none",
    "illustrationPlan": "Arthur O'Neill, Patrick Byrne, and the nineteenth-century stage",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-17-from-wax-cylinder-to-streaming-media-generations": {
    "kind": "none",
    "illustrationPlan": "From wax cylinder to streaming: media generations",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-18-george-petrie-breathnach-and-the-archive-century": {
    "kind": "none",
    "illustrationPlan": "George Petrie, Breathnach, and the archive century",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-19-james-morrison-the-professor": {
    "kind": "none",
    "illustrationPlan": "James Morrison: \"The Professor\" — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-20-paddy-killoran-and-the-new-york-studio-network": {
    "kind": "none",
    "illustrationPlan": "Paddy Killoran and the New York studio network",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-22-na-píobairí-uilleann-and-craft-transmission": {
    "kind": "none",
    "illustrationPlan": "Na Píobairí Uilleann and craft transmission",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-23-closing-history-as-toolkit": {
    "kind": "none",
    "illustrationPlan": "Closing: history as toolkit — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-06-history-sec-24-chieftains-planxty-and-the-concert-stage": {
    "kind": "none",
    "illustrationPlan": "Chieftains, Planxty, and the concert stage",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-kp-1": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-kp-2": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-kp-3": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-1-overview": {
    "kind": "none",
    "illustrationPlan": "Overview — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-3-formation-and-scene": {
    "kind": "none",
    "illustrationPlan": "Formation and scene — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-4-key-acts-and-members": {
    "kind": "none",
    "illustrationPlan": "Key acts and members — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-5-musical-approach": {
    "kind": "none",
    "illustrationPlan": "Musical approach — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-7-legacy": {
    "kind": "none",
    "illustrationPlan": "Legacy — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-9-formation-and-context": {
    "kind": "none",
    "illustrationPlan": "Formation and context — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-10-big-tom-and-the-mainliners": {
    "kind": "none",
    "illustrationPlan": "Big Tom and The Mainliners — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-11-daniel-odonnell": {
    "kind": "none",
    "illustrationPlan": "Daniel O'Donnell — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-13-formation": {
    "kind": "none",
    "illustrationPlan": "Formation — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-17-legacy": {
    "kind": "none",
    "illustrationPlan": "Legacy — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-19-formation": {
    "kind": "none",
    "illustrationPlan": "Formation — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-20-key-members-and-musical-approach": {
    "kind": "none",
    "illustrationPlan": "Key members and musical approach — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-22-legacy": {
    "kind": "none",
    "illustrationPlan": "Legacy — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-24-formation": {
    "kind": "none",
    "illustrationPlan": "Formation — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-27-legacy": {
    "kind": "none",
    "illustrationPlan": "Legacy — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-29-formation": {
    "kind": "none",
    "illustrationPlan": "Formation — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-31-landmark-albums": {
    "kind": "none",
    "illustrationPlan": "Landmark albums — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-32-legacy": {
    "kind": "none",
    "illustrationPlan": "Legacy — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-34-formation-and-core-lineup": {
    "kind": "none",
    "illustrationPlan": "Formation and core lineup — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-38-legacy": {
    "kind": "none",
    "illustrationPlan": "Legacy — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-43-legacy": {
    "kind": "none",
    "illustrationPlan": "Legacy — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-48-legacy": {
    "kind": "none",
    "illustrationPlan": "Legacy — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-53-legacy": {
    "kind": "none",
    "illustrationPlan": "Legacy — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-58-legacy": {
    "kind": "none",
    "illustrationPlan": "Legacy — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-68-legacy": {
    "kind": "none",
    "illustrationPlan": "Legacy — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-70-dropkick-murphys": {
    "kind": "none",
    "illustrationPlan": "Dropkick Murphys — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-71-flogging-molly": {
    "kind": "none",
    "illustrationPlan": "Flogging Molly — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-76-legacy": {
    "kind": "none",
    "illustrationPlan": "Legacy — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-78-formation-and-key-figures": {
    "kind": "none",
    "illustrationPlan": "Formation and key figures — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-81-legacy": {
    "kind": "none",
    "illustrationPlan": "Legacy — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-85-legacy": {
    "kind": "none",
    "illustrationPlan": "Legacy — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-88-chicago-and-francis-oneill": {
    "kind": "none",
    "illustrationPlan": "Chicago and Francis O'Neill — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-92-listening-map-starting-points": {
    "kind": "none",
    "illustrationPlan": "Listening map (starting points) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-07-representative-depth-sec-93-how-the-branches-connect": {
    "kind": "none",
    "illustrationPlan": "How the branches connect — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-08-tunes-kp-1": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-08-tunes-kp-2": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-08-tunes-kp-3": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-08-tunes-sec-1-overview": {
    "kind": "none",
    "illustrationPlan": "Overview — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-08-tunes-sec-2-the-silver-spear": {
    "kind": "none",
    "illustrationPlan": "The Silver Spear — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-08-tunes-sec-4-more-session-standards": {
    "kind": "none",
    "illustrationPlan": "More session standards — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-08-tunes-tune-silver-spear": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: The Silver Spear — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-ireland-regions-celtic-ireland-08-tunes-tune-kesh-jig": {
    "kind": "none",
    "illustrationPlan": "Ireland trad: The Kesh Jig — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  }
}

export default EXAMPLES
